// @flow

export const SLIDER_CONFIG = Object.freeze({
  selectors: {
    mask: '[data-slider-mask]',
    slide: '[data-slider-slide]',
    leftArrow: '[data-slider-arrow="left"]',
    rightArrow: '[data-slider-arrow="right"]',
    stateDisable: 'state--disabled',
  },
  remainingSlides: 3,
})
